import React, { useEffect, useState } from 'react';
import { documentTypeServices } from '../../../APIServices/documentTypeServices';
import Pagination from '../../../hooks/Pagination';

function DeletedDocumentTypeHistory({
  getDocumentTypeData,
  setModalOpen,
  deletedPageNumber,
  setDeletedPageNumber,
  deletedItemsPerPage,
  setDeletedItemsPerPage,
  deleteDocumentTypeList,
  deleteDocumentTypeCount,
  getDeletedDocumentTypeData,
}) {
  const [buttonLoader, setButtonLoader] = useState(false);
  const totalPage = Math.ceil(deleteDocumentTypeCount / deletedItemsPerPage);

  const softDeleteRestoreDocumentType = async (id) => {
    setButtonLoader(true);
    const data = await documentTypeServices.softDeleteRestoreDocumentType({
      id,
      type: 'restore',
    });
    if (data?.statusCode === 200) {
      getDocumentTypeData();
      getDeletedDocumentTypeData();
    }
    setButtonLoader(false);
  };

  const deleteDocumentTypeData = async (id) => {
    setButtonLoader(true);
    const data = await documentTypeServices.deleteDocumentTypeData({ id });
    if (data?.statusCode === 200) {
      getDeletedDocumentTypeData();
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    getDeletedDocumentTypeData();
  }, [deletedPageNumber, deletedItemsPerPage]);

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 620 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Deleted Document Type List</div>
            <div className="xs muted">Restore and permanent delete document types</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <table className="tbl">
            <thead>
              <tr>
                <th>Document Type</th>
                <th style={{ width: 140 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {deleteDocumentTypeList.map((item) => (
                <tr key={item._id}>
                  <td className="medium">{item.documentType}</td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="icon-btn"
                        title="Restore"
                        style={{ color: 'var(--info)' }}
                        onClick={() => softDeleteRestoreDocumentType(item?._id)}
                        disabled={buttonLoader}
                      >
                        <i className="ti ti-rotate" />
                      </button>
                      <button
                        className="icon-btn"
                        title="Permanent Delete"
                        style={{ color: 'var(--danger)' }}
                        onClick={() => deleteDocumentTypeData(item?._id)}
                        disabled={buttonLoader}
                      >
                        <i className="ti ti-trash-x" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            itemsPerPage={deletedItemsPerPage}
            setItemsPerPage={setDeletedItemsPerPage}
            pageNumber={deletedPageNumber}
            setPageNumber={setDeletedPageNumber}
            totalPage={totalPage}
            totalItems={deleteDocumentTypeCount}
          />
        </div>
      </div>
    </div>
  );
}

export default DeletedDocumentTypeHistory;